import { StepDefinition } from '../types/SimilarlySituated/StepDefinition.type';

export const SSB_STEP_HEADERS = {
  Define: {
    title: 'Box builder: define your case types',
    description:
      'Use case type cards to define conditions for cases to include or exclude from the box to create a universe of similarly situated cases. You can select specific offenses or groupings of offenses alleged, disposition of the case, and/or defendant characteristics. Multiple case types can be created and do not need to be mutually exclusive. The box will include all cases that match any of the conditions defined by your case type card(s). You can also create exclusion criteria to remove cases across the box.',
  },
  Analyze: {
    title: 'Analysis selector',
    description:
      'Select one or more analyses to run for the box. Note: you cannot select analyses for a stage preceding the one defined in the box.',
  },
  Results: {
    title: 'Results',
    description: 'Review the results tables for each analysis selected. One analysis is displayed per page.',
  },
} satisfies Partial<Record<StepDefinition, { title: string; description: string }>>;
